module.exports = __webpack_public_path__ + "img/06.5cc1a2cb.png";